<template>
<div>
  <el-table :data="exportData.list">
    <el-table-column type="index" :label="$t('zhiji.knowlege.imExHistoryModal.order')" width="80" />
    <el-table-column :label="$t('zhiji.knowlege.imExHistoryModal.exprotScene')" width="250">
      <template slot-scope="scope">
        {{ getSecenPath(scope.row) }}
      </template>
    </el-table-column>
    <el-table-column :label="$t('zhiji.knowlege.imExHistoryModal.exportStatus')">
      <template slot-scope="scope">
        <div v-if="language==='cn'">
        <span v-if="scope.row.task_status === 2">导出完成，成功导出{{ scope.row.standards_num }}条标准问题，{{ scope.row.similar_num }}条相似问题，{{ scope.row.answer_num }}条答案，实际导出{{ scope.row.total_num || 0 }}条。</span>
        <span v-else>{{ scope.row.state }}</span>
        </div>
        <div v-else>
        <span v-if="scope.row.task_status === 2">Export completed,successfully exported{{ scope.row.standards_num }} standard questions,{{ scope.row.similar_num }}similar question,{{ scope.row.answer_num }}answers,actually exported{{ scope.row.total_num || 0 }}。</span>
        <span v-else>{{ scope.row.state }}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column :label="$t('zhiji.knowlege.imExHistoryModal.exportEndTime')" width="180">
      <template slot-scope="scope">
        <span v-if="scope.row.task_status === 0">{{$t('zhiji.knowlege.imExHistoryModal.waiting')}}</span>
        <span v-else-if="scope.row.task_status === 1">{{ scope.row.end_time }}({{$t('zhiji.knowlege.imExHistoryModal.estimated')}})</span>
        <span v-else>{{ scope.row.update_time }}</span>
      </template>
    </el-table-column>
    <el-table-column property="operator" :label="$t('zhiji.knowlege.imExHistoryModal.operator')" width="100" />
    <el-table-column :label="$t('zhiji.knowlege.imExHistoryModal.operation')" width="130">
      <template slot-scope="scope">
        <el-link v-if="scope.row.task_status === 2 && scope.row.down_url" type="primary" @click="downErrorData(scope.row.down_url)">{{$t('zhiji.knowlege.imExHistoryModal.downloadForm')}}</el-link>
        <span v-if="scope.row.task_status === 3">{{$t('zhiji.knowlege.imExHistoryModal.contact')}}</span>
      </template>
    </el-table-column>
  </el-table>
  <FooterPage
    :size="exportData.size"
    :total="exportData.total"
    :page="exportData.page"
    @sizeChange="sizeChange"
    @pageChange="pageChange"
  />
</div>
</template>

<script>
import FooterPage from '@/views/zhiji/components/foot-page.vue'
import checkAuth from "@/lib/auth";

export default {
  name: 'ExportStatus',
   components: {
    FooterPage
  },
  props: {
    status: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      exportData: {
        list: [],
        page: 1,
        size: 10,
        total: 1,
      },
      language: '',
    };
  },
  watch: {
    status (modelStatus) {
      // eslint-disable-next-line no-unused-expressions
      modelStatus && this.getExportData();
    },
   "$i18n.locale": {
       handler(value) {
           this.language = value;
       },
       immediate: true
   },
  },
  mounted () {
    this.getExportData();
  },
  methods: {
    async getExportData () {
      const { list,count } = await this.zhiji.requestByServiceName("getFaqExportList",{
        page: this.exportData.page,
        size: this.exportData.size,
      });
      this.exportData.list = list;
      this.exportData.total = count;
    },
    sizeChange (newSize) {
      this.exportData.size = newSize;
      this.exportData.page = 1;
      this.getExportData();
    },
    pageChange (newPage) {
      this.exportData.page = newPage;
      this.getExportData();
    },
    // 下载导入错误信息表
    downErrorData (url) {
      if (!checkAuth("knowledge.fqamanager.export")) {
        this.$message.error("您没有导出权限，无法下载文件");
        return;
      }
      window.open(url);
    },
    getSecenPath (row) {
      const data = row.scene;
      if (row.is_filter === 1) return this.$i18n.t('zhiji.knowlege.imExHistoryModal.filterExport');
      if (data.length === 0) return this.$i18n.t('zhiji.knowlege.imExHistoryModal.exportAll');
      return this.flatObj(data,'');
    },
    flatObj(obj, str) {
        if (obj.set_name) {
            str = str ? obj.set_name + ">" + str : obj.set_name;
        }
        if (obj.parent_set && Object.keys(obj.parent_set).length > 0) {
            return this.flatObj(obj.parent_set, str);
        } else {
            return str;
        }
    }
  },
};
</script>
